import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ShoppingCart, Calendar, Building2, History } from "lucide-react";
import ProveedoresTab from "@/components/compras/ProveedoresTab";
import OrdenesCompraTab from "@/components/compras/OrdenesCompraTab";
import CalendarioEntregasTab from "@/components/compras/CalendarioEntregasTab";
import HistorialComprasProductoTab from "@/components/compras/HistorialComprasProductoTab";

export const SecretariaComprasTab = () => {
  const [activeTab, setActiveTab] = useState("ordenes");

  return (
    <div className="space-y-4">
      {/* Header */}
      <div>
        <h2 className="text-xl font-semibold flex items-center gap-2">
          <ShoppingCart className="h-5 w-5 text-pink-600" />
          Módulo de Compras
        </h2>
        <p className="text-sm text-muted-foreground">
          Gestión de proveedores, órdenes de compra y entregas
        </p>
      </div>

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-2 lg:grid-cols-4">
          <TabsTrigger value="ordenes" className="gap-2">
            <ShoppingCart className="h-4 w-4" />
            <span className="hidden sm:inline">Órdenes de Compra</span>
            <span className="sm:hidden">OC</span>
          </TabsTrigger>
          <TabsTrigger value="proveedores" className="gap-2">
            <Building2 className="h-4 w-4" />
            <span className="hidden sm:inline">Proveedores</span>
            <span className="sm:hidden">Provs</span>
          </TabsTrigger>
          <TabsTrigger value="calendario" className="gap-2">
            <Calendar className="h-4 w-4" />
            <span className="hidden sm:inline">Calendario</span>
            <span className="sm:hidden">Cal</span>
          </TabsTrigger>
          <TabsTrigger value="historial" className="gap-2">
            <History className="h-4 w-4" />
            <span className="hidden sm:inline">Historial</span>
            <span className="sm:hidden">Hist</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="ordenes" className="mt-4">
          <OrdenesCompraTab />
        </TabsContent>

        <TabsContent value="proveedores" className="mt-4">
          <ProveedoresTab />
        </TabsContent>

        <TabsContent value="calendario" className="mt-4">
          <CalendarioEntregasTab />
        </TabsContent>

        <TabsContent value="historial" className="mt-4">
          <HistorialComprasProductoTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};
